/**
 * GpsTracker — thin wrapper around navigator.geolocation.watchPosition.
 * Emits 'gps:update' on every fix, 'gps:error' on failure.
 *
 * Uses enableHighAccuracy=true to match the old gps-tracker.html behaviour.
 */
export class GpsTracker {
    constructor(_bus) {
        this._bus = _bus;
        this._watchId = null;
    }
    get isAvailable() {
        return typeof navigator !== 'undefined' && 'geolocation' in navigator;
    }
    get isRunning() {
        return this._watchId !== null;
    }
    start() {
        if (!this.isAvailable) {
            this._bus.emit('gps:error', { message: 'Geolocation not available in this browser' });
            return;
        }
        if (this._watchId !== null)
            return;
        this._watchId = navigator.geolocation.watchPosition((geoPos) => {
            const pos = {
                lat: geoPos.coords.latitude,
                lon: geoPos.coords.longitude,
                accuracy: Number.isFinite(geoPos.coords.accuracy) ? geoPos.coords.accuracy : null,
                speed: Number.isFinite(geoPos.coords.speed) ? geoPos.coords.speed : null,
                heading: Number.isFinite(geoPos.coords.heading) ? geoPos.coords.heading : null,
                timestamp: geoPos.timestamp,
            };
            this._bus.emit('gps:update', pos);
        }, (err) => {
            this._bus.emit('gps:error', { message: err.message, code: err.code });
        }, { enableHighAccuracy: true });
    }
    stop() {
        if (this._watchId !== null) {
            navigator.geolocation.clearWatch(this._watchId);
            this._watchId = null;
        }
    }
}
//# sourceMappingURL=GpsTracker.js.map